import { getCustomerManager } from "@iewccouk/Services/AccountManagerService";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    onSuccess(result: any): any;
    customerId: string;
}
interface Props {
    apiResult: any;
    apiParameter: any;
}

type HandlerType = Handler<Parameter, Props> & HasOnSuccess;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.customerId;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCustomerManager(props.apiParameter);
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};
const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];
const getCustomerManagerInfo = createHandlerChainRunner(chain, "getCustomerManagerInfo");
export default getCustomerManagerInfo;
